export function getTranslate(element) {
    let transform = element.style.cssText.match(/translate\((.*)\)/)
    if (transform) {
        transform = transform[1]
        transform = transform.split(',')
        if (transform[0].charAt(transform[0].length - 1) === '%') {
            return { x: Number((transform[0].slice(0, transform[0].length - 1) / 100) * element.clientWidth), y: Number((transform[1].slice(0, transform[1].length - 1) / 100) * element.clientHeight) }
        } else {
            return { x: Number(transform[0].slice(0, transform[0].length - 2)), y: Number(transform[1].slice(0, transform[1].length - 2)) }
        }
    }
    return { x: 0, y: 0 }
}

export function fullScreen(DomElement) {
    if (DomElement.requestFullscreen) {
        DomElement.requestFullscreen()
    } else if (DomElement.webkitRequestFullScreen) {
        DomElement.webkitRequestFullScreen()
    } else if (DomElement.mozRequestFullScreen) {
        DomElement.mozRequestFullScreen()
    } else if (DomElement.msRequestFullscreen) {
        // IE11
        DomElement.msRequestFullscreen()
    }
}